import React, { FC } from 'react'
import { Skeleton, Stack, TableCell, TableRow, Typography } from '@mui/material'

import {
  DataTable,
  type DataTableColumn,
  EmptyState,
} from '@/apps/latest/components/portal/notion'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'
import { DrugGroup } from '@/features/internal/drugs/types/soapTemplate'

interface Props {
  groups: DrugGroup[]
  loading: boolean
  onRowClick: (groupId: string) => void
}

const COLUMNS: DataTableColumn[] = [
  { key: 'name', label: 'グループ名' },
  { key: 'description', label: '説明' },
  { key: 'drug_count', label: '医薬品数', align: 'right' },
  { key: 'template_group_count', label: 'テンプレート数', align: 'right' },
]

// 医薬品グループ一覧。行クリックで詳細へ (常設の行内ボタンは置かない)。
export const DrugGroupTable: FC<Props> = ({ groups, loading, onRowClick }) => {
  if (loading) {
    return (
      <Stack gap={1}>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rectangular" height={40} />
        ))}
      </Stack>
    )
  }

  if (groups.length === 0) {
    return (
      <EmptyState
        title="まだグループがありません"
        hint="「新規グループ」から作成してください"
      />
    )
  }

  return (
    <DataTable columns={COLUMNS}>
      {groups.map((group) => (
        <TableRow
          key={group.id}
          hover
          onClick={() => onRowClick(group.id)}
          sx={{ cursor: 'pointer' }}
        >
          <TableCell>{group.name}</TableCell>
          <TableCell>
            <Typography sx={PORTAL_TEXT.cellSecondary} component="span">
              {group.description || '—'}
            </Typography>
          </TableCell>
          <TableCell align="right">{group.drug_count}</TableCell>
          <TableCell align="right">{group.template_group_count}</TableCell>
        </TableRow>
      ))}
    </DataTable>
  )
}

export default DrugGroupTable
